<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path d="M8.78782 1.60263C9.28302 0.599255 10.7138 0.599249 11.209 1.60263L13.567 6.38036L18.8395 7.1465C19.9468 7.3074 20.3889 8.66816 19.5877 9.44918L15.7724 13.1681L16.6731 18.4193C16.8622 19.5222 15.7047 20.3632 14.7143 19.8425L9.99842 17.3632L5.28252 19.8425C4.29213 20.3632 3.13459 19.5222 3.32374 18.4193L4.2244 13.1681L0.409159 9.44919C-0.392086 8.66816 0.0500454 7.3074 1.15735 7.1465L6.42988 6.38036L8.78782 1.60263Z" fill="#FFC259"/>
  </svg>
</template>
